export default "__VITE_ASSET__Vtm9GSxk__"